import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

interface PropertyCardProps {
  name: string | null;
  address: string | null;
}

export const PropertyCard = ({ name, address }: PropertyCardProps) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Información general</CardTitle>
      </CardHeader>
      <CardContent>
        <dl className="space-y-4">
          <div>
            <dt className="text-base font-medium text-muted-foreground">Nombre</dt>
            <dd className="text-base">{name}</dd>
          </div>
          <div>
            <dt className="text-base font-medium text-muted-foreground">Dirección</dt>
            <dd className="text-base">{address}</dd>
          </div>
        </dl>
      </CardContent>
    </Card>
  );
};